import { API_URL_NUPY } from '@/toolbox/defaults/app';
import axios from 'axios';

export const TipoImpuestoRepository = {
    
    get: async(): Promise<any> => {
        const res = await axios.get(`${API_URL_NUPY}/tipoImpuesto/list`);
        return res.data;
    },
}